var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconEventhosting30 = function SvgAIconEventhosting30(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    stroke: "currentColor",
    "aria-hidden": true
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3068 28.067C13.7518 28.4296 13.2913 28.6995 12.9741 28.8767C12.6799 29.0411 12.3188 29.0411 12.0247 28.8767C9.85628 27.6641 1 22.1238 1 12.2507C1 6.03711 6.14873 1 12.5 1C16.7035 1 20.3803 3.20641 22.3863 6.5",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9998 26C25.418 26 28.9996 22.4183 28.9996 18C28.9996 13.5817 25.418 10 20.9998 10C16.5816 10 13 13.5817 13 18C13 22.4183 16.5816 26 20.9998 26Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3652 18H24.638",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 21.6362L21 14.3635",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAIconEventhosting30 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciI+CjxwYXRoIGQ9Ik0xNC4zMDY4IDI4LjA2N0MxMy43NTE4IDI4LjQyOTYgMTMuMjkxMyAyOC42OTk1IDEyLjk3NDEgMjguODc2N0MxMi42Nzk5IDI5LjA0MTEgMTIuMzE4OCAyOS4wNDExIDEyLjAyNDcgMjguODc2N0M5Ljg1NjI4IDI3LjY2NDEgMSAyMi4xMjM4IDEgMTIuMjUwN0MxIDYuMDM3MTEgNi4xNDg3MyAxIDEyLjUgMUMxNi43MDM1IDEgMjAuMzgwMyAzLjIwNjQxIDIyLjM4NjMgNi41IiBzdHJva2Utd2lkdGg9IjEuNiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIwLjk5OTggMjZDMjUuNDE4IDI2IDI4Ljk5OTYgMjIuNDE4MyAyOC45OTk2IDE4QzI4Ljk5OTYgMTMuNTgxNyAyNS40MTggMTAgMjAuOTk5OCAxMEMxNi41ODE2IDEwIDEzIDEzLjU4MTcgMTMgMThDMTMgMjIuNDE4MyAxNi41ODE2IDI2IDIwLjk5OTggMjZaIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8cGF0aCBkPSJNMTcuMzY1MiAxOEgyNC42MzgiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+CjxwYXRoIGQ9Ik0yMSAyMS42MzYyTDIxIDE0LjM2MzUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+Cjwvc3ZnPg==";